import {useState, useEffect, useMemo} from "react"
import axios from "axios"
import {API_PROJECTS} from "../../constants/apiUrls"
import {useTranslation} from "react-i18next"
import Select from "react-select"
import {labelMap} from "../../constants/multilingual"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import {useStWorkflowContext} from "../../reactContext/contextCustomHooks/useStWorkflowContext"
import isLicenceValidity from "../../tools/isLicenceValidity"
import {toast} from "react-toastify"

export default function StWorkflowRender({project, destinationLanguage, langCode, exportStProject}) {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {teamContext} = useTeamContext()
    const {setStWorkflowAction} = useStWorkflowContext()
    const [videoUrl, setVideoUrl] = useState([])
    const [SRTLang, setSRTLang] = useState(project.lang_code)
    const allLanguages = useMemo(() => {
        let destinationLanguageTmp = destinationLanguage.map((lang) => ({
            value: lang.code,
            label: t(labelMap[lang.code]),
        }))
        destinationLanguageTmp.push({
            value: langCode,
            label: t(labelMap[langCode]),
        })
        return destinationLanguageTmp.sort((a, b) => a.label.localeCompare(b.label))
    }, [destinationLanguage, langCode, labelMap])

    const getVideoURL = (codeISO) => {
        const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}
        axios.get(`${API_PROJECTS}/${project.id}/transcription`, headersRequest, {maxRedirects: 0})
        .then(() => {
            axios.get(`${API_PROJECTS}/${project.id}/exports/${codeISO}`, headersRequest, {maxRedirects: 0})
            .then((response) => {
                setVideoUrl(response.data)
            })
            .catch((error) => {
                console.error("GET /projects/project/exports/fr: ", error)
            })
        })
        .catch((error) => {
            console.error("GET /projects/project/transcription: ", error)
        })
    }

    const exportProject = () => {
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            setStWorkflowAction({type: "ST_WORKFLOW_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: true, id: project.id}}})
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."))
        }
    }

    useEffect(() => {
        getVideoURL(SRTLang)
    }, [SRTLang])

    return (
        <>
        <div className="SECTION ST-WORKFLOW-RENDER">
            <div className="header">
            <div className="header-content">
                <p>{t("Language")} :</p>
                <Select
                    defaultValue={{
                        value: langCode,
                        label: t(labelMap[langCode]),
                    }}
                    name="languages"
                    options={allLanguages}
                    isClearable={false}
                    isSearchable={false}
                    className="basic-single"
                    classNamePrefix="select"
                    onChange={(value) => {setSRTLang(value.value)}}
                />
                </div>
            </div>
            <video controls crossOrigin="anonymous" src={videoUrl} type="video/mp4"></video>
            {project.archive_status === "done" ?
                <button className="export-enable" onClick={project.finished ? exportStProject : exportProject} title={t("Export")}>{t("Export")}</button>
                :
                <button className="export-disable" title={t("Export")}>{t("Export")}</button>
            }
        </div>
        </>
    )
}